<template>
  <div class="personalPage commBg">
    <div class="container">
      <el-row :gutter="50">
        <el-col :span="8">
          <div class="personalPage-box">
            <div class="personalPage-tit">
              <img src="../../assets/images/icon/icon_taobao.png"><h2>淘宝流量剩余<span>{{taobaoCount}}</span>条</h2>
            </div>
            <div class="personalPage-list">
              <ul>
                <li class="clearfix">
                  <span class="tit">PC流量： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money1 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">APP流量： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money2 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">搜索收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money5 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">商品收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money11 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">店铺收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money7 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">搜索加购： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money6 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">猜你喜欢： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money3 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">淘口令： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money4 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">旺旺打标： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money8 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">每日好店： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money10 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">聚划算： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money12 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">直接加购： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money13 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">淘抢购： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money14 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">达人关注： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money15 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">直播观看： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money16 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">逛逛点赞： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{money17 || 0}}</b>条</span>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="personalPage-box">
            <div class="personalPage-tit">
              <img src="../../assets/images/icon/icon_jd.png"><h2>京东流量剩余<span>{{jdCount}}</span>条</h2>
            </div>
            <div class="personalPage-list">
              <ul>
                <li class="clearfix">
                  <span class="tit">App流量： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{jdmoney1 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">店铺收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{jdmoney2 || 0}}</b>条</span>
                </li>
               <li class="clearfix">
                  <span class="tit">搜索加购： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{jdmoney3 || 0}}</b>条</span>
                </li>
                <!--
               <li class="clearfix">
                 <span class="tit">直接加购： </span>
                 <span class="remain">剩余</span>
                 <span class="number"><b>{{jdmoney4 || 0}}</b>条</span>
               </li>-->
                <!--<li class="clearfix">
                  <span class="tit">搜索收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{jdmoney5 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">直接收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{jdmoney6 || 0}}</b>条</span>
                </li>-->
              </ul>
            </div>
          </div>
          <!-- <div class="personalPage-box mt20">
            <div class="personalPage-tit">
              <img src="../../assets/images/icon/icon_douyin.png"><h2>抖音流量剩余<span>{{douyinCount}}</span>条</h2>
            </div>
            <div class="personalPage-list">
              <ul>
                <li class="clearfix">
                  <span class="tit">抖音关注： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{douyin1 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">抖音点赞： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{douyin2 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">抖音播放： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{douyin3 || 0}}</b>条</span>
                </li>
              </ul>
            </div>
          </div> -->
        </el-col>
        <el-col :span="8">
          <div class="personalPage-box">
            <div class="personalPage-tit">
              <img src="../../assets/images/icon/icon_pdd.png"><h2>拼多多流量剩余<span>{{pdCount}}</span>条</h2>
            </div>
            <div class="personalPage-list">
              <ul>
                <li class="clearfix">
                  <span class="tit">APP流量： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{pddmoney1 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">店铺收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{pddmoney2 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">搜索收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{pddmoney3 || 0}}</b>条</span>
                </li>
                <li class="clearfix">
                  <span class="tit">商品收藏： </span>
                  <span class="remain">剩余</span>
                  <span class="number"><b>{{pddmoney4 || 0}}</b>条</span>
                </li>
              </ul>
            </div>
          </div>

        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import http from '../../axios'
export default{
  data () {
    return {
      ptType: [], // 平台类型
      allInfo: [{
        platformType: 'pinduoduo',
        flowType: '08',
        countRemainder: 94
      }, {
        platformType: 'taobao',
        flowType: '01',
        countRemainder: 13
      }, {
        platformType: 'pinduoduo',
        flowType: '08',
        countRemainder: 94
      }],
      taobaoInfo: [],
      taobaoCount: 0,
      jdInfo: [],
      jdCount: 0,
      pddInfo: [],
      pdCount: 0,
      douyinInfo: [],
      douyinCount: 0,
      money1: '',
      money2: '',
      money3: '',
      money4: '',
      money5: '',
      money6: '',
      money7: '',
      money8: '',
      money9: '',
      money10: '',
      money11: '',
      money12: '',
      money13: '',
      money14: '',
      money15: '',
      money16: '',
      money17: '',
      jdmoney1: '',
      jdmoney2: '',
      jdmoney3: '',
      jdmoney4: '',
      jdmoney5: '',
      jdmoney6: '',
      pddmoney1: '',
      pddmoney2: '',
      pddmoney3: '',
      pddmoney4: '',
      douyin1: '',
      douyin2: '',
      douyin3: '',
      douyin4: ''
    }
  },
  methods: {
    // 获取列表
    getDataList () {
      const _this = this
      if (!localStorage.getItem('info')) {
        this.$message({
          type: 'warning',
          message: '请登录后使用'
        })
        this.$router.push({path: '/login'})
        return
      }
      try {
        http.custmerCenter('').then(({ data }) => {
          switch (data.code) {
            case 0:
              _this.allInfo = data.userMoney
              _this.allInfo.forEach((item, index) => {
                if (item.platform === 1) {
                  switch (item.module) {
                    case 1:
                      _this.money1 = item.money
                      break
                    case 2:
                      _this.money2 = item.money
                      break
                    case 3:
                      _this.money3 = item.money
                      break
                    case 4:
                      _this.money4 = item.money
                      break
                    case 5:
                      _this.money5 = item.money
                      break
                    case 6:
                      _this.money6 = item.money
                      break
                    case 7:
                      _this.money7 = item.money
                      break
                    case 8:
                      _this.money8 = item.money
                      break
                    case 9:
                      _this.money9 = item.money
                      break
                    case 10:
                      _this.money10 = item.money
                      break
                    case 11:
                      _this.money11 = item.money
                      break
                    case 12:
                      _this.money12 = item.money
                      break
                    case 13:
                      _this.money13 = item.money
                      break
                    case 14:
                      _this.money14 = item.money
                      break
                    case 15:
                      _this.money15 = item.money
                      break
                    case 16:
                      _this.money16 = item.money
                      break
                    case 17:
                      _this.money17 = item.money
                      break
                    default:

                      break
                  }
                  _this.taobaoCount += item.money
                } else if (item.platform === 3) {
                  switch (item.module) {
                    case 2:
                      _this.pddmoney1 = item.money
                      break
                    case 5:
                      _this.pddmoney3 = item.money
                      break
                    case 11:
                      _this.pddmoney4 = item.money
                      break
                    default:
                      _this.pddmoney2 = item.money
                      break
                  }
                  _this.pdCount += item.money
                } else if (item.platform === 2) {
                  switch (item.module) {
                    case 2:
                      _this.jdmoney1 = item.money
                      break
                    case 7:
                      _this.jdmoney2 = item.money
                      break
                    case 5:
                      _this.jdmoney5 = item.money
                      break
                    case 11:
                      _this.jdmoney6 = item.money
                      break
                    case 13:
                      _this.jdmoney4 = item.money
                      break
                    default:
                      _this.jdmoney3 = item.money
                      break
                  }
                  _this.jdCount += item.money
                } else if (item.platform === 4) {
                  switch (item.module) {
                    case 18:
                      _this.douyin1 = item.money
                      break
                    case 19:
                      _this.douyin2 = item.money
                      break
                    case 20:
                      _this.douyin3 = item.money
                      break
                    default:
                      break
                  }
                  _this.douyinCount += item.money
                }
              })
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 1170px;
  margin: auto;
  // min-height:767px;
  box-shadow:0px 0px 4px 0px rgba(0, 0, 0, 0.35);
  border-radius:5px;
  padding: 50px 15px;
  margin-top: 20px;
  margin-bottom: 40px;
}
.personalPage-box{
  border:1px solid #dedede;
  border-radius: 30px;
  background-color: #fff;
  // padding: 0 15px 15px 30px;
  // height: 865px;
}
.personalPage-tit{
  // text-align: center;
  margin-bottom: 40px;
  background: #EEEEEE;
  border-radius: 30px 30px 0px 0px;
  padding: 28px 15px;
  img{
    width: 40px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }
  h2{
    display: inline-block;
    vertical-align: middle;
    font-size: 20px;
    color: #FC6B0E;
    span{
      display: inline-block;
      max-width: 90px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
      vertical-align: bottom;
    }
  }

}
.personalPage-list{
  padding: 0 8px;
  li{
    margin-bottom: 12px;
    background: #EEEEEE;
    padding: 8px 15px;
  }
  li span{
    display: inline-block;
  }
  li span.tit{
    width: 32%;
    text-align: left;
    color: #FC6B0E;
  }
  li span.remain{
    width: 20%;
    text-align: center;
    color: #666666;
  }
  li span.number{
    width: 44%;
    text-align: right;
    color: #666666;
    b{
      color: #FC6B0E;
      margin-right: 8px;
      font-size: 17px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userCenter.vue